export default "__VITE_ASSET__cb96e836__"